// visitors.effects.ts

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { VisitorsService } from 'app/core/service/visitors.service';
import {
   PostVisitor,
   PostVisitorSuccess,
   PostVisitorError,
   GetVisitors,
   GetVisitorsSuccess, 
   GetVisitorsError,
   GetReasons,
   GetReasonsSuccess,
   GetReasonsError,
   GetDestinations,
   GetDestinationsSuccess,
   GetDestinationsError,
   GetSingleVisitor,
   GetSingleVisitorSuccess,
   GetSingleVisitorError,
   EditVisitor,
   EditVisitorSuccess,
   EditVisitorError,
   DeleteVisitor,
   DeleteVisitorSuccess,
   DeleteVisitorError
} from '../actions/visitors.actions';
import { VisitorsAction } from '../constants';

@Injectable()
export class VisitorsEffects {

   postVisitor$ = createEffect(() =>
       this.actions$.pipe(
           ofType<PostVisitor>(VisitorsAction.PostVisitor),
           switchMap((action: any) =>
               this.visitorsService.postVisitor(action.data).pipe(
                   mergeMap((visitor: any) => {
                       return of(new PostVisitorSuccess(visitor));
                   }),
                   catchError((error) => {
                       return of(new PostVisitorError());
                   }),
               )
           ),
       ),
   );

   getVisitors$ = createEffect(() =>
    this.actions$.pipe(
        ofType<GetVisitors>(VisitorsAction.GetVisitors),
        switchMap((action: any) =>
            this.visitorsService.getVisitors(action.data).pipe(
                mergeMap((response: any) => {
                    const visitors = response.results || response; // Transformamos aquí
                    return of(new GetVisitorsSuccess(visitors));
                }),
                catchError((error) => {
                    return of(new GetVisitorsError());
                }),
            )
        ),
    ),
   );

   getReasons$ = createEffect(() =>
       this.actions$.pipe(
           ofType<GetReasons>(VisitorsAction.GetReasons),
           switchMap(() =>
               this.visitorsService.getReasons().pipe(
                   mergeMap((reasons: any) => {
                       return of(new GetReasonsSuccess(reasons));
                   }),
                   catchError((error) => {
                       return of(new GetReasonsError());
                   }),
               )
           ),
       ),
   );

   getDestinations$ = createEffect(() =>
       this.actions$.pipe(
           ofType<GetDestinations>(VisitorsAction.GetDestinations),
           switchMap(() =>
               this.visitorsService.getDestinations().pipe(
                   mergeMap((destinations: any) => {
                       return of(new GetDestinationsSuccess(destinations));
                   }),
                   catchError((error) => {
                       return of(new GetDestinationsError());
                   }),
               )
           ),
       ),
   );

   getSingleVisitor$ = createEffect(() =>
       this.actions$.pipe(
           ofType<GetSingleVisitor>(VisitorsAction.GetSingleVisitor),
           switchMap((action: any) =>
               this.visitorsService.getSingleVisitor(action.visitorId).pipe(
                   mergeMap((visitor: any) => {
                       return of(new GetSingleVisitorSuccess(visitor));
                   }),
                   catchError((error) => {
                       return of(new GetSingleVisitorError());
                   }),
               )
           ),
       ),
   );

   editVisitor$ = createEffect(() =>
       this.actions$.pipe(
           ofType<EditVisitor>(VisitorsAction.EditVisitor),
           switchMap((action: any) =>
               this.visitorsService.editVisitor(action.data).pipe(
                   mergeMap((visitor: any) => {
                       return of(new EditVisitorSuccess(visitor));
                   }),
                   catchError((error) => {
                       return of(new EditVisitorError());
                   }),
               )
           ),
       ),
   );

   deleteVisitor$ = createEffect(() =>
       this.actions$.pipe(
           ofType<DeleteVisitor>(VisitorsAction.DeleteVisitor),
           switchMap((action: any) =>
               this.visitorsService.deleteVisitor(action.visitorId).pipe(
                   mergeMap((response: any) => {
                       return of(new DeleteVisitorSuccess(action.visitorId));
                   }),
                   catchError((error) => {
                       return of(new DeleteVisitorError());
                   }),
               )
           ),
       ),
   );

   constructor(
       private visitorsService: VisitorsService,
       private actions$: Actions,
   ) { }
}